"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useCompoundButton_unstable", {
    enumerable: true,
    get: ()=>useCompoundButton_unstable
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _reactUtilities = require("@fluentui/react-utilities");
const _index = require("../Button/index");
const useCompoundButton_unstable = ({ contentContainer , secondaryContent , ...props }, ref)=>{
    var _state_icon, _state_secondaryContent;
    const state = {
        // Button state
        ...(0, _index.useButton_unstable)(props, ref),
        // Slots definition
        components: {
            root: 'button',
            icon: 'span',
            contentContainer: 'span',
            secondaryContent: 'span'
        },
        contentContainer: (0, _reactUtilities.resolveShorthand)(contentContainer, {
            required: true
        }),
        secondaryContent: (0, _reactUtilities.resolveShorthand)(secondaryContent)
    };
    // Recalculate iconOnly to take into account secondaryContent.
    state.iconOnly = Boolean(((_state_icon = state.icon) === null || _state_icon === void 0 ? void 0 : _state_icon.children) && !props.children && !((_state_secondaryContent = state.secondaryContent) === null || _state_secondaryContent === void 0 ? void 0 : _state_secondaryContent.children));
    return state;
}; //# sourceMappingURL=useCompoundButton.js.map

//# sourceMappingURL=useCompoundButton.js.map